import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useContent } from "../context/SiteContentContext";

export default function WhatsAppButton() {
  const { get } = useContent();
  return (
    <motion.a
      href={`https://wa.me/${get("site.whatsapp")}?text=${encodeURIComponent(get("site.whatsapp_greeting"))}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full flex items-center justify-center"
      style={{
        backgroundColor: "#25D366",
      }}
      aria-label="Chat on WhatsApp"
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ duration: 0.8, delay: 2.2, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.15, rotate: 5 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* Pulsing ring */}
      <motion.span
        className="absolute inset-0 rounded-full"
        style={{ backgroundColor: "#25D366" }}
        animate={{ scale: [1, 1.6], opacity: [0.5, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeOut" }}
      />
      <MessageCircle className="text-white relative z-10" size={26} />
    </motion.a>
  );
}
